/**
 * Even though we use the Providers enum from the platform types, we need these to
 * map the provider to the correct URL for sign-in.
 */
export enum ProvidersForSignIn {
  MicrosoftAzureAD = 'azure-ad',
  SalesforceSandbox = 'salesforce-sandbox',
  CopadoCICD = 'cicd', // Used in Functional reviews
}

export enum LoginMode {
  Email = 'email',
  SSO = 'sso',
  Saml = 'saml',
}

export const PASSWORD_REG_EXP = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
